import classNames from 'classnames';
import React from 'react';
import { defaultWrapper } from "./DefaultBreadcrumbItemWrapper.js";
import { IconRenderer } from "../../../helper/components/IconRenderer.js";
import styles from "./BreadcrumbItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function BreadcrumbItem({
  breadcrumb,
  active,
  wrapperComponent
}) {
  const WrapperComponent = wrapperComponent ?? defaultWrapper;
  return /*#__PURE__*/_jsxs(WrapperComponent, {
    to: breadcrumb.href,
    className: classNames(styles.breadcrumbItem, {
      [styles.active]: active
    }),
    children: [/*#__PURE__*/_jsx(IconRenderer, {
      className: styles.icon,
      icon: breadcrumb.icon,
      size: "SMALL"
    }), /*#__PURE__*/_jsxs("span", {
      className: styles.linkText,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.visibleItem,
        children: breadcrumb.label
      }), /*#__PURE__*/_jsx("span", {
        className: styles.hiddenItem,
        "aria-hidden": true,
        children: breadcrumb.label
      })]
    })]
  });
}